import { AxiosError } from 'axios';
import { useMutation } from 'react-query';
import { useAuthSelector } from 'app/data/auth';
import { sdk } from 'app/sdk';

export const useDeleteVmbox = () => {
  const authState = useAuthSelector();
  return useMutation<any, AxiosError, string, unknown>((vmboxId: string) =>
    sdk.vmbox.mutate.delete(vmboxId, authState?.auth_token),
  );
};
